export enum OfferStepsEnum {
    BasicInfo = 100,
    Calculator = 250,
    Applicants = 500,
    Additional = 750,
    Offers = 1000,
    DocumentsHome = 2000,
    DocumentsMoney = 2200,
    DocumentsAdditional = 2450,
    DocumentsIdentification = 2700,
    DocumentsApplication = 2800,
    DocumentsApproval = 2850,
    DocumentsMortgage = 2900,
    ForDrawing = 3000,
    AfterDrawing = 3500,
    Caretaker = 4000,
}

export interface IOfferStep {
    name: string;
    fillingScore: OfferStepsEnum;
    url: string;
    summaryUrl?: string;
    refinancing?: boolean;
}

export interface IOfferStepMenu {
    name: string;
    url: string;
    urlMobile?: string;
    smartlookClass: string;
    fillingScoreStart: OfferStepsEnum;
    fillingScoreEnd: OfferStepsEnum;
    overrideToActualStep?: boolean; // if true, menu entry use OfferSevice.navigateToActualStep()
}

export const OfferStepsMenu: IOfferStepMenu[] = [
    {
        name: 'O hypotéce',
        smartlookClass: 'o-hypotece',
        url: '/calculator/overview',
        urlMobile: '/mobile/calculator/overview',
        fillingScoreStart: OfferStepsEnum.BasicInfo,
        fillingScoreEnd: OfferStepsEnum.Additional,
    },
    {
        name: 'Řešení',
        smartlookClass: 'nabidka',
        url: '/offers/',
        fillingScoreStart: OfferStepsEnum.Offers,
        fillingScoreEnd: OfferStepsEnum.Offers,
    },
    {
        name: 'Žádost',
        smartlookClass: 'zadost',
        url: '/documents/overview',
        urlMobile: '/mobile/documents/overview',
        fillingScoreStart: OfferStepsEnum.DocumentsHome,
        fillingScoreEnd: OfferStepsEnum.DocumentsApplication,
        overrideToActualStep: true,
    },
    {
        name: 'Schvalování',
        smartlookClass: 'schvalovani',
        url: '/acceptance/overview',
        urlMobile: '/mobile/acceptance/overview',
        fillingScoreStart: OfferStepsEnum.DocumentsApproval,
        fillingScoreEnd: OfferStepsEnum.DocumentsMortgage,
    },
    {
        name: 'Schváleno',
        smartlookClass: 'cerpani',
        url: '/draw/overview',
        urlMobile: '/mobile/draw/overview',
        fillingScoreStart: OfferStepsEnum.ForDrawing,
        fillingScoreEnd: OfferStepsEnum.AfterDrawing,
    },
    {
        name: 'Hlídač',
        smartlookClass: 'hlidac',
        url: '/caretaker/overview',
        urlMobile: '/mobile/caretaker/overview',
        fillingScoreStart: OfferStepsEnum.Caretaker,
        fillingScoreEnd: OfferStepsEnum.Caretaker,
    },
];

export const OfferStepsDesktop: IOfferStep[] = [
    {
        name: 'O hypotéce',
        fillingScore: OfferStepsEnum.BasicInfo,
        url: '/calculator/basic-info',
        summaryUrl: '/calculator/overview',
    },
    {
        name: 'O hypotéce',
        fillingScore: OfferStepsEnum.Calculator,
        url: '/calculator/offers',
        summaryUrl: '/calculator/overview',
    },
    {
        name: 'O hypotéce',
        fillingScore: OfferStepsEnum.Calculator,
        url: '/calculator/refinancing',
        summaryUrl: '/calculator/overview',
        refinancing: true,
    },
    {
        name: 'O hypotéce',
        fillingScore: OfferStepsEnum.Applicants,
        url: '/calculator/applicants',
        summaryUrl: '/calculator/overview',
    },
    {
        name: 'O hypotéce',
        fillingScore: OfferStepsEnum.Additional,
        url: '/calculator/additional',
        summaryUrl: '/calculator/overview',
    },
    {
        name: 'Řešení',
        fillingScore: OfferStepsEnum.Offers,
        url: '/offers',
    },
    {
        name: 'Žádost',
        fillingScore: OfferStepsEnum.DocumentsHome,
        url: '/documents/applicants-home',
        summaryUrl: '/documents/overview',
    },
    {
        name: 'Žádost',
        fillingScore: OfferStepsEnum.DocumentsMoney,
        url: '/documents/applicants-money',
        summaryUrl: '/documents/overview',
    },
    {
        name: 'Žádost',
        fillingScore: OfferStepsEnum.DocumentsAdditional,
        url: '/documents/additional',
        summaryUrl: '/documents/overview',
    },
    {
        name: 'Žádost',
        fillingScore: OfferStepsEnum.DocumentsIdentification,
        url: '/documents/overview',
    },
    {
        name: 'Žádost',
        fillingScore: OfferStepsEnum.DocumentsApplication,
        url: '/documents/overview',
    },
    {
        name: 'Schvalování',
        fillingScore: OfferStepsEnum.DocumentsApproval,
        url: '/acceptance/overview',
    },
    {
        name: 'Schváleno',
        fillingScore: OfferStepsEnum.DocumentsMortgage,
        url: '/acceptance/overview',
    },
    {
        name: 'Schváleno',
        fillingScore: OfferStepsEnum.ForDrawing,
        url: '/draw/overview',
    },
    {
        name: 'Schváleno',
        fillingScore: OfferStepsEnum.AfterDrawing,
        url: '/draw/overview',
    },
    {
        name: 'Hlídač',
        fillingScore: OfferStepsEnum.Caretaker,
        url: '/caretaker/overview',
    },
];

export const OfferStepsMobile: IOfferStep[] = [
    {
        name: 'O hypotéce',
        fillingScore: OfferStepsEnum.BasicInfo,
        url: '/mobile/calculator/basic-info',
        summaryUrl: '/mobile/calculator/overview',
    },
    {
        name: 'O hypotéce',
        fillingScore: OfferStepsEnum.Applicants,
        url: '/mobile/calculator/applicants',
        summaryUrl: '/mobile/calculator/overview',
    },
    {
        name: 'O hypotéce',
        fillingScore: OfferStepsEnum.Additional,
        url: '/mobile/calculator/additional',
        summaryUrl: '/mobile/calculator/overview',
    },
    {
        name: 'Řešení',
        fillingScore: OfferStepsEnum.Offers,
        url: '/mobile/offers',
    },
    {
        name: 'Žádost',
        fillingScore: OfferStepsEnum.DocumentsHome,
        url: '/mobile/documents/applicants-home',
        summaryUrl: '/mobile/documents/overview',
    },
    {
        name: 'Žádost',
        fillingScore: OfferStepsEnum.DocumentsMoney,
        url: '/mobile/documents/applicants-money',
        summaryUrl: '/mobile/documents/overview',
    },
    {
        name: 'Žádost',
        fillingScore: OfferStepsEnum.DocumentsAdditional,
        url: '/mobile/documents/additional',
        summaryUrl: '/mobile/documents/overview',
    },
    {
        name: 'Žádost',
        fillingScore: OfferStepsEnum.DocumentsIdentification,
        url: '/mobile/documents/overview',
    },
    {
        name: 'Žádost',
        fillingScore: OfferStepsEnum.DocumentsApplication,
        url: '/mobile/documents/overview',
    },
    {
        name: 'Schvalování',
        fillingScore: OfferStepsEnum.DocumentsApproval,
        url: '/mobile/acceptance/overview',
    },
    {
        name: 'Schváleno',
        fillingScore: OfferStepsEnum.DocumentsMortgage,
        url: '/mobile/acceptance/overview',
    },
    {
        name: 'Schváleno',
        fillingScore: OfferStepsEnum.ForDrawing,
        url: '/mobile/draw/overview',
    },
    {
        name: 'Schváleno',
        fillingScore: OfferStepsEnum.AfterDrawing,
        url: '/mobile/draw/overview',
    },
    {
        name: 'Hlídač',
        fillingScore: OfferStepsEnum.Caretaker,
        url: '/mobile/caretaker/overview',
    },
];
